import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';

import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { InvoicesModule } from './invoices/invoices.module';
import { ReportsRoutingModule } from './reports-routing.module';

import {ReportsComponent} from './reports.component';
import { BatchExportComponent } from './batch-export/batch-export.component';
import { BatchExportSmartComponent } from './batch-export/batch-export-smart.component';
import { RealTimeTransactionsComponent } from './real-time-transactions/real-time-transactions.component';
import { RealTimeTransactionsSmartComponent } from './real-time-transactions/real-time-transactions-smart.component';
import { CommisionSmartComponent } from './commision/commision-smart.component';
import { CommisionComponent } from './commision/commision.component';
import { SalesSummaryComponent } from './sales-summary/sales-summary.component';
import { SalesSummarySmartComponent } from './sales-summary/sales-summary-smart.component';
import { RetailerAcquisitionComponent } from './retailer-acquisition/retailer-acquisition.component';
import { RetailerAcquisitionSmartComponent } from './retailer-acquisition/retailer-acquisition-smart.component';
import { LoyaltyReportComponent } from './loyalty-report/loyalty-report.component';
import { LoyaltyReportSmartComponent } from './loyalty-report/loyalty-report-smart.component';
import { PaymentReportSmartComponent } from './payment-report/payment-report-smart.component';
import { PaymentReportComponent } from './payment-report/payment-report.component';
import { CreateBatchComponent } from './batch-export/create-batch/create-batch.component';
import { RefundComponent } from './refund/refund.component';
import { RefundSmartComponent } from './refund/refund-smart.component';
import { TransactionSummarySmartComponent } from './transaction-summary/transaction-summary-smart.component';
import { TransactionSummaryComponent } from './transaction-summary/transaction-summary.component';

@NgModule({
  declarations: [
    ReportsComponent,
    BatchExportComponent,
    BatchExportSmartComponent,
    RealTimeTransactionsComponent,
	RealTimeTransactionsSmartComponent,
    CommisionComponent,
    CommisionSmartComponent,
    SalesSummaryComponent,
	SalesSummarySmartComponent,
    RetailerAcquisitionComponent,
	RetailerAcquisitionSmartComponent,
    LoyaltyReportComponent,
	LoyaltyReportSmartComponent,
    PaymentReportComponent,
	PaymentReportSmartComponent,
	CreateBatchComponent,
	RefundComponent,
	RefundSmartComponent,
    TransactionSummaryComponent,
	TransactionSummarySmartComponent
],
  imports: [
    FeaturesCommonModule,
    AgGridModule.withComponents([]),
    ReportsRoutingModule
]
})
export class ReportsModule { }
